import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { policySelector } from '../../selectors';
import * as policyActions from '../../actions/policyActions';
import * as profileActions from '../../actions/profileActions';

import Section from '../../components/Section';
import { Policy } from '../../components/sections';

import { Grid, Dropdown } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import VMasker from 'vanilla-masker';
import { policyIcon } from '../../helpers/policy';

class PolicySection extends Component {
	constructor(props) {
		super(props);

		const { policy } = this.props;
		const defaultPolicy = !!policy && !!policy.items && policy.items.length > 0 ? policy.items[0] : {};
		this.state = {
			showAddPolicy: false,
			showEditPolicy: false,
			tempNickname: null,
			showAddSuccess: false,
			showRemovePolicy: false,
			activeMenuItem: 'information',
			selectedPolicy: defaultPolicy,
			attempt: 0,
		};

		this.onListItemClick = this.onListItemClick.bind(this);
		this.onAddPolicy = this.onAddPolicy.bind(this);
		this.onAddClicked = this.onAddClicked.bind(this);
		this.onCancelClicked = this.onCancelClicked.bind(this);
		this.onFieldChange = this.onFieldChange.bind(this);
		this.onMenuItemClick = this.onMenuItemClick.bind(this);
		this.removePolicy = this.removePolicy.bind(this);
		this.onAddContinueClicked = this.onAddContinueClicked.bind(this);
		this.onEditNickname = this.onEditNickname.bind(this);
		this.onUpdateNickname = this.onUpdateNickname.bind(this);
		this.onPolicyDropdownChange = this.onPolicyDropdownChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		const { deepLink, onDeepLinkComplete } = this.props;
		const { selectedPolicy } = this.state;
		const policies = this.props.policy.items;
		
		if (deepLink) {
			const requestedPolicy = policies.find((p) => p.policyNumber.toUpperCase() === deepLink.policyNumber.toUpperCase());
			this.setState({ selectedPolicy: requestedPolicy, activeMenuItem: 'documents' });
			if (onDeepLinkComplete) onDeepLinkComplete();
		} else {
			if (!selectedPolicy.id && prevProps.policy !== this.props.policy) {
				const { policy } = this.props;
				const defaultPolicy = !!policy && !!policy.items && policy.items.length > 0 ? policy.items[0] : {};
				this.setState({
					selectedPolicy: defaultPolicy,
				});
			}
		}
	}

	onListItemClick(_, { data }) {
		this.setState({ selectedPolicy: data });
	}

	onPolicyDropdownChange(e, { value }) {
		const policy = this.props.policy.items.find((p) => p.policyNumber === value);
		this.setState({ selectedPolicy: policy });
	}

	onAddPolicy() {
		this.setState({ showAddPolicy: true, attempt: 0 });
	}

	onFieldChange(e) {
		const { actions, policy } = this.props;

		if (e.target.name === 'driversLicenseNumber') {
			VMasker(e.target).maskPattern('SSSSSSSSSSSS');
		}

		policy.add[e.target.name] = e.target.value;
		actions.updateNewPolicy(policy.add);
	}

	async onAddClicked() {
		const { attempt } = this.state;
		this.setState({ attempt: attempt + 1 });

		const { policy, actions } = this.props;
		try {
			await actions.addPolicy(policy.add);
			this.setState({ showAddSuccess: true });
		} catch (error) {
			throw error;
		}
	}

	async onAddContinueClicked(e) {
		e.preventDefault();
		const { actions } = this.props;
		try {
			this.setState({ showAddPolicy: false, showAddSuccess: false });
			const profileResult = await actions.getProfile();
			await actions.getPolicies(profileResult.response.policies);
		} catch (error) {
			throw error;
		}
	}

	async removePolicy(e) {
		const { actions } = this.props;
		const { selectedPolicy } = this.state;
		await actions.removePolicy(selectedPolicy);
		this.setState({ showRemovePolicy: false });
		const profileResult = await actions.getProfile();
		await actions.getPolicies(profileResult.response.policies);
	}

	onCancelClicked(e) {
		const { actions } = this.props;

		actions.clearNewPolicy();

		this.setState({ showAddPolicy: false, showRemovePolicy: false, showEditPolicy: false, tempNickname: null });
	}

	onEditNickname(e) {
		this.setState({ tempNickname: e.target.value });
	}

	async onUpdateNickname(e) {
		const { actions } = this.props;
		const { selectedPolicy, tempNickname } = this.state;
		const policy = { ...selectedPolicy, nickname: tempNickname };
		try {
			await actions.updatePolicy(policy);
			this.setState({ showEditPolicy: false, tempNickname: null, selectedPolicy: policy });
		} catch (error) {
			throw error;
		}
	}

	onMenuItemClick(_, { name }) {
		const { selectedPolicy } = this.state;
		const { actions } = this.props;

		if (name === 'makeChange') {
			actions.push('/policy/update/' + selectedPolicy.policyNumber);
			return;
		}

		if (name === 'delete') return this.setState({ showRemovePolicy: true });
		if (name === 'edit') return this.setState({ showEditPolicy: true, tempNickname: selectedPolicy.nickname });

		this.setState({
			activeMenuItem: name,
		});
	}

	render() {
		const { showAddPolicy, showEditPolicy, showAddSuccess, showRemovePolicy, activeMenuItem, selectedPolicy, tempNickname, attempt } = this.state;
		const policies = this.props.policy.items;
		const newPolicy = this.props.policy.add;
		const editPolicy = this.props.policy.edit;

		const policyOptions = policies.map((policy) => {
			return { text: `${policy.nickname} (${policy.policyNumber})`, value: policy.policyNumber, data: policy };
		});

		const policyListItems = policies.map((policy, index) => {
			return <Policy.ListItem key={index} icon={policyIcon(policy.policyNumber)} nickName={policy.nickname} policyNumber={policy.policyNumber} onClick={this.onListItemClick} data={policy} active={selectedPolicy.policyNumber === policy.policyNumber} effective={policy.effective} expiration={policy.expiration} type={policy.type} status={policy.statusText} />;
		});

		return (
			<Section name='policies' title='Policies' color='red' mobileShow={this.props.mobileShow}>
				<Policy.ModalEdit loading={editPolicy.loading} open={showEditPolicy} nickname={tempNickname} onCancel={this.onCancelClicked} onSave={this.onUpdateNickname} onFieldChange={this.onEditNickname} error={editPolicy.error} />
				<Policy.ModalAdd loading={newPolicy.loading} open={showAddPolicy} onAdd={this.onAddClicked} onCancel={this.onCancelClicked} onFieldChange={this.onFieldChange} policyNumber={newPolicy.policyNumber || ''} error={newPolicy.error} showSuccess={showAddSuccess} onSuccess={this.onAddContinueClicked} attempt={attempt} />
				<Policy.ModalRemove open={showRemovePolicy} onYes={this.removePolicy} onCancel={this.onCancelClicked} policy={selectedPolicy} />
				<Grid>
					<Grid.Column width='4' className='tablet only computer only'>
						<Policy.List>
							{policyListItems}
							<Policy.ItemAdd onClick={this.onAddPolicy} />
						</Policy.List>
					</Grid.Column>
					<Grid.Column className='left divider' mobile={16} computer={12} tablet={12}>
						<Dropdown className='mobile only' value={selectedPolicy.policyNumber} fluid selection options={policyOptions} onChange={this.onPolicyDropdownChange} />
						<Policy.Details activeItem={activeMenuItem} onMenuItemClick={this.onMenuItemClick} policy={selectedPolicy} onAddPolicy={this.onAddPolicy} />
					</Grid.Column>
				</Grid>
			</Section>
		);
	}
}

PolicySection.propTypes = {
	actions: PropTypes.object.isRequired,
	policy: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
	return {
		policy: policySelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(policyActions, dispatch),
		...bindActionCreators(profileActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PolicySection);
